import { useDispatch, useSelector } from 'react-redux';
import {
  MarkdownContainerCaseOpening,
  ImageContainer,
  Main,
  MainRow,
  MarkdownSecondaryContainerCaseOpening,
  RetractableRow,
  FAQContainer,
  MarkdownTitleContainerCaseOpening,
} from './CaseOpeningDesktopStyled';
import { Banner, Button } from '@integration/alexandria-ui';
import Markdown from 'components/Markdown';
import SuccessIcon from 'components/Icons/SuccessIcon/SuccessIcon';
import {
  homepageVideoLinkSelector,
  imageHomeUrlSelector,
  shouldPlaceVideoOnHomeDesktopSelector,
} from 'redux/selectors/config';
import { useUnavailabilityBanner } from 'hooks/unavailability-hooks';
import { useTranslateByProject } from 'hooks/translation-hooks';
import { CenteredRow, Column } from 'globalStyles/Containers';
import { BigTitleBold, LargeBodyRegular } from 'globalStyles/Text';
import { moveToNextStep, updateCurrentStep } from 'redux/actions/stepActions';
import { useEffect } from 'react';
import FAQAccordeon from '../FAQ/FAQAccordeon';

export const CaseOpeningDesktop = () => {
  const t = useTranslateByProject();
  const dispatch = useDispatch();
  const backgroundImage = useSelector(imageHomeUrlSelector);
  const homepageVideoLink = useSelector(homepageVideoLinkSelector);
  const shouldPlaceVideoOnHomeDesktop = useSelector(
    shouldPlaceVideoOnHomeDesktopSelector,
  );
  const { showUnavailabilityBanner, title, message } =
    useUnavailabilityBanner();
  useEffect(() => {
    dispatch(updateCurrentStep({}));
  }, [dispatch]);
  const goToNextStep = () => dispatch(moveToNextStep());

  return (
    <>
      {showUnavailabilityBanner && (
        <Banner
          type={'INFO'}
          containerClassName="home-unavailability-banner"
          shouldShowCloseIcon={false}
          title={<Markdown text={title} />}
          text={<Markdown text={message} />}
        />
      )}
      <Main>
        <MainRow gap={'24'}>
          <Column gap={'32'}>
            <MarkdownTitleContainerCaseOpening data-testid={'intro-page'}>
              <Markdown text={t('home-content-markdown')}></Markdown>
            </MarkdownTitleContainerCaseOpening>
            <RetractableRow gap={'24'}>
              <CenteredRow gap={'16'}>
                <SuccessIcon
                  data-testid="check-circle"
                  color="iconAction_5"
                  width={'32'}
                  height={'32'}
                />
                <BigTitleBold>
                  {t('home-content-satisfied_users-number')}
                </BigTitleBold>
                <LargeBodyRegular color={'textSecondary'}>
                  {t('home-content-satisfied_users-label')}
                </LargeBodyRegular>
              </CenteredRow>
              <CenteredRow gap={'16'}>
                <SuccessIcon
                  data-testid="check-circle"
                  color="iconAction_5"
                  width={'32'}
                  height={'32'}
                />
                <BigTitleBold>
                  {t('home-content-resolved_cases-number')}
                </BigTitleBold>
                <LargeBodyRegular color={'textSecondary'}>
                  {t('home-content-resolved_cases-label')}
                </LargeBodyRegular>
              </CenteredRow>
            </RetractableRow>
            <Button onClick={goToNextStep} data-testid="use-alternative">
              {t('home-request_assistance-button')}
            </Button>
          </Column>
          <ImageContainer backgroundImage={backgroundImage} />
        </MainRow>
        {shouldPlaceVideoOnHomeDesktop && (
          <CenteredRow gap={'24'}>
            <iframe
              src={homepageVideoLink}
              title="YouTube video player"
              frameBorder="8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
            <MarkdownSecondaryContainerCaseOpening
              data-testid={'video_section'}
            >
              <Markdown text={t('home-video_content-markdown')}></Markdown>
            </MarkdownSecondaryContainerCaseOpening>
          </CenteredRow>
        )}
        <FAQContainer>
          <MarkdownContainerCaseOpening data-testid={'video_section'}>
            <Markdown text={t('home-faq-markdown')}></Markdown>
          </MarkdownContainerCaseOpening>
          <FAQAccordeon />
        </FAQContainer>
      </Main>
    </>
  );
};

export default CaseOpeningDesktop;
